import Regex from "./regex";

const { AccountName, PrivateKey, PublicKey, CompositionName, FieldName } = Regex;

export const testPermissionName = (value) => {
    return AccountName.test(value);
}

export const validateIndexName = (value) => {
    return AccountName.test(value);
}

export const valiedateNameField = (value) => {
    return AccountName.test(value);
}

export const testPrivateKey = (value) => {
    return PrivateKey.test(value);
}

export const testPublicKey = (value) => {
    return PublicKey.test(value);
}

export const validateURL = (url) => {
    try {
        const parsedURL = new URL(url);
        return parsedURL.protocol === 'http:' || parsedURL.protocol === 'https:';
    } catch (e) {
        return false;
    }
}

export const validateMultiFormatFile = (format) => {
    switch (format) {
        case "json":
        case "csv":
        case "xml":
            return true;
        default:
            return false;
    }
}

export const validateCompositionName = (value, compositions) => {
    if (typeof value !== 'string' || value !== value.trim()) {
        return false;
    }
    const lowerValue = value.toLowerCase();

    const cppReservedKeywords = new Set(["class", "bool", "false", "true"]);

    if (cppReservedKeywords.has(lowerValue) || compositions.has(value)) {
        return false;
    }

    return CompositionName.test(value);
}

export const validateFieldName = (value) => {
    return FieldName.test(value);
}